import { Component } from "react";

class Dashboard extends Component {
  render() {
    return null;
  }
}

export default Dashboard;
